import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MousePointer2 = createReactComponent("MousePointer2", ["svg", defaultAttributes, [["path", {
  d: "M4 4l7.07 17 2.51-7.39L21 11.07z",
  key: "1rpga0"
}]]]);
export default MousePointer2;